var render = function render(){var _vm=this,_c=_vm._self._c;return _c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.localValue),expression:"localValue"}],staticClass:"form-control",attrs:{"name":_vm.name,"rows":_vm.rows},domProps:{"value":(_vm.localValue)},on:{"input":function($event){if($event.target.composing)return;_vm.localValue=$event.target.value}}})
}
var staticRenderFns = []

export { render, staticRenderFns }